import * as React from 'react';

import AdminSyncTypePickerView from 'admin/rostering/components/AdminSyncTypePickerView';
import { SyncType } from 'globalTypes';

type Props = {
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
  syncType: SyncType;
  displaySyncType: (syncType: SyncType) => void;
};

class AdminSyncTypePickerContainer extends React.Component<Props> {
  handleHideRequest = () => {
    this.props.onClose();
  };

  handleContinue = (syncType: SyncType) => {
    this.props.selectSyncType(syncType);
    this.handleHideRequest();
  };

  render() {
    const { syncType, displaySyncType } = this.props;

    // Renders Classlink, OneRoster and CSV2.0
    return (
      <React.Fragment>
        <AdminSyncTypePickerView
          data-test={`sis-setup-picker-view`}
          syncType={syncType}
          displaySyncType={displaySyncType}
          handleContinue={this.handleContinue}
        />
      </React.Fragment>
    );
  }
}

export default AdminSyncTypePickerContainer;
